import { faker } from '@faker-js/faker/locale/es';
import type { Person } from './types';
import type { WorkOrderRow } from './workOrderGenerator';

export interface MESEventRow {
  id: string;
  timestamp: string;        // legacy "HH:MM:SS"
  isoTimestamp: string;
  type: string;
  station: string;
  user: string;
  status: 'OK' | 'WARNING' | 'ERROR' | 'INFO';
  detail: string;
}

const TYPES = ['PRODUCTION', 'QUALITY', 'MAINTENANCE', 'LOGISTICS', 'SAFETY'];
const STATUS_MIX: Array<{ value: MESEventRow['status']; weight: number }> = [
  { value: 'OK', weight: 0.80 },
  { value: 'INFO', weight: 0.10 },
  { value: 'WARNING', weight: 0.07 },
  { value: 'ERROR', weight: 0.03 },
];

const DETAILS = [
  'Unidad completada en estación',
  'Inspección visual pasada',
  'Cambio de herramienta completado',
  'Calibración verificada',
  'Componente consumido',
  'Pause programado · descanso',
  'Setup completado',
  'Lote enviado a almacén',
  'Operario iniciado en estación',
  'Reporte de turno enviado',
];

export function generateEvents(workOrders: WorkOrderRow[], people: Person[], count: number = 150): MESEventRow[] {
  const events: MESEventRow[] = [];
  const activeWOs = workOrders.filter((w) => w.status === 'IN_PROGRESS' || w.status === 'COMPLETED');

  for (let i = 0; i < count; i++) {
    const wo = faker.helpers.arrayElement(activeWOs);
    const ts = faker.date.recent({ days: 1 });
    const operator = people.find((p) => p.id === wo.operatorId) ?? faker.helpers.arrayElement(people);
    events.push({
      id: `EVT-${String(1000 + i)}`,
      timestamp: ts.toLocaleTimeString('es-ES'),
      isoTimestamp: ts.toISOString(),
      type: faker.helpers.arrayElement(TYPES),
      station: wo.stationName,
      user: operator.fullName,
      status: faker.helpers.weightedArrayElement(STATUS_MIX),
      detail: faker.helpers.arrayElement(DETAILS),
    });
  }

  return events.sort((a, b) => +new Date(b.isoTimestamp) - +new Date(a.isoTimestamp));
}
